import { RecurrencePattern } from "./task";
export const touchpointKinds = ["email", "call", "text", "visit"];
export const touchpointTypes = [
    "visit",
    "call",
    "text",
    "email",
    "note",
    "event",
    "gift",
];
export const touchpointTypeLabels = {
    visit: "Visit",
    call: "Call",
    text: "Text",
    email: "Email",
    note: "Note / Card",
    event: "Event",
    gift: "Gift",
};
export const touchpointTypeForKind = (kind) => kind;
export const cadenceUnits = [
    RecurrencePattern.Daily,
    RecurrencePattern.Weekly,
    RecurrencePattern.Monthly,
];
//# sourceMappingURL=touchpoint.js.map